/**
 * @file PrivateRoute.js
 * @description Componente de React que protege rutas, asegurando que solo los usuarios autenticados puedan acceder a ellas.
 * Si un usuario no está autenticado, es redirigido a la página de inicio de sesión.
 */
import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import AuthContext from '../context/AuthContext';

/**
 * @function PrivateRoute
 * @description Componente funcional que envuelve otras rutas.
 * Verifica el estado de autenticación del usuario a través de `AuthContext`.
 * Si el usuario está autenticado, renderiza los componentes hijos (`children`).
 * De lo contrario, redirige al usuario a la página de login.
 * @param {Object} props - Propiedades del componente.
 * @param {React.ReactNode} props.children - Los componentes hijos que se renderizarán si el usuario está autenticado.
 * @returns {JSX.Element} Los componentes hijos si el usuario está autenticado, o un componente `Navigate` a la página de login.
 */
const PrivateRoute = ({ children }) => {
    let { user } = useContext(AuthContext);
    return user ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
